import React, { useState, useEffect, useRef } from 'react';
import WaitingIndicator from '../general-components/waiting-indicator';
import { getAssetUri } from '../../utils/utils';
import { isValidImage } from '../../utils/media';
import TellyAction from '../../images/telly_action.png';

interface Thumbnail {
	thumbnail?: string | undefined,
	className?: string,
}

const validThumbs: any[] = [];
const deadThumbs: any[] = [];

export default function Thumbnail({ thumbnail, className }: Thumbnail) {
	const [uriValid, setUriValid] = useState(thumbnail && validThumbs?.includes(thumbnail));
	const uriTimeout = useRef<NodeJS.Timeout | null>(setTimeout(() => { }, 1));
	const tries = useRef<number>(0);
	const [badThumb, setBadThumb] = useState(false);

	async function check(uri: string) {
		const img = new Image();
		const valid = await isValidImage(uri, img);

		if (valid) {
			if (uriTimeout.current) {
				setUriValid(true);
			}
			validThumbs.push(uri);
			clearInterval(uriTimeout.current!);
		} else {
			tries.current += 1;
		}

		if (tries.current > 3) {
			deadThumbs.push(uri);
			setBadThumb(true);
			clearInterval(uriTimeout.current!);
		}
	}

	useEffect(() => {
		if (uriTimeout.current) clearInterval(uriTimeout.current);
		if (thumbnail && !validThumbs?.includes(thumbnail) && !deadThumbs?.includes(thumbnail)) {
			check(thumbnail);

			uriTimeout.current = setInterval(() => {
				check(thumbnail);
			}, 1000);
		}

		return () => {
			if (uriTimeout.current) {
				clearInterval(uriTimeout.current);
				uriTimeout.current = null;
			}
		};
	}, [thumbnail]);

	return uriValid ? (
		<img src={thumbnail?.includes('https:') ? thumbnail : getAssetUri(thumbnail!)} alt={''} className={className} />
	) : (
		<div className="attachment-waiting">
			{badThumb || (thumbnail && deadThumbs.includes(thumbnail)) ? <img src={TellyAction} className={className}></img> : <WaitingIndicator />}

		</div>
	);
}
